import type { TranslationKeys } from "@/i18n/translations";
import type { UserRead } from "@/types/auth";

export function getUserFirstName(user: UserRead | null | undefined): string {
  const source = user?.display_name?.trim() || user?.email?.trim() || "";
  if (!source) return "";
  const firstToken = source.split(/\s+/)[0]?.trim() || "";
  return firstToken.split("@")[0];
}

export function getTimeOfDayGreetingKey(
  date: Date = new Date(),
): "welcome.greeting.morning" | "welcome.greeting.afternoon" | "welcome.greeting.evening" {
  const hour = date.getHours();
  if (hour < 12) return "welcome.greeting.morning";
  if (hour < 17) return "welcome.greeting.afternoon";
  return "welcome.greeting.evening";
}

export function buildWelcomeTitle(
  t: (key: TranslationKeys) => string,
  user: UserRead | null | undefined,
  date: Date = new Date(),
): string {
  const greeting = t(getTimeOfDayGreetingKey(date));
  const firstName = getUserFirstName(user);
  return firstName ? `${greeting}, ${firstName}` : greeting;
}
